import { xlCol, xlColq } from "../../../common/constants"

export const headCellStyles = {
    borderStyle: 'solid',
    borderWidth: '0px',
    backgroundColor: "#BFE1FF",
    color: '#444444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    minCellHeight: '44px',
    padding: '7px 12px 7px 12px',
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    textAlign:'left'
}

export const cellStyles = {
    minCellHeightheight: '50px',
    padding: '7px 12px',
    alignItems: 'flexStart',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    textAlign:'left',
    color: '#444444'
}

export const totalRowStyles = {
    minCellHeightheight: '36px',
    padding: '7px 12px',
    backgroundColor: "#eeeeee",
    textAlign: "right",
    color: '#444444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    borderBottom: 'none'
}

export const paymentTypeStyles = {
  fontSize: '12px',
  borderRadius: '30px',
 // textOverflow: 'ellipsis',
 // overflow: 'hidden',
  width: '6vw'
}

export const statusCellStyles = {
  padding: '4px 9px',
  fontSize: '12px',
  borderRadius: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '6vw',
  verticalAlign:'top',
  fontFamily:'Roboto'
}

export const trimmedTextStyle = {
    fontSize: '12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '9vw'
  }

  export const bookingDeliveryTrackingColumns = [
    {
      header: 'LR No.',
      pdfHead: 'LR No.\nMan. LR No.',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 1,
    },
    {
      header: 'Booking Date & Time',
      pdfHead: 'Bkg. Date\nBkg. Time',
      field: 'BookingDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 2,
    },
    {
      header: 'Source City & Source Branch',
      pdfHead: 'Src. City\nSrc. Br.',
      field: 'srcCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 3,
    },
    {
      header: 'Destination City & Destination Branch',
      pdfHead: 'Dest. City\nDest. Br.',
      field: 'destCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,  
      isMandatory: true,
      id: 4,
    },
    {
      header: 'Sender Name & Sender No.',
      pdfHead: 'Sndr. Name<br />Sndr. No.',
      field: 'sndrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 5,
    },
    {
      header: 'Sender GSTIN & Sender Email',
      pdfHead: 'Sndr. GSTIN\nSndr. eMail',
      field: 'sndrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 6,
    },
    {
      header: 'Receiver Name & Receiver No.',
      pdfHead: 'Rcvr. Name<br />Rcvr. No.',
      field: 'rcvrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 7,
    },
    {
      header: 'Receiver GSTIN & Receiver eMail',
      pdfHead: 'Rcvr. GSTIN<br />Rcvr. eMail ',
      field: 'rcvrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 8,
    },
    {
      header: 'Party Bill No. & Party Bill Date',
      pdfHead: 'Party Bill No.\nParty Bill Dt.',
      field: 'partyBillNoDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 9,
    },
    {
      header: 'Payment Type',
      pdfHead: 'Pymt.\nType',
      field: 'PaymentType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 10,
    },
    {
      header: 'Eway Bill No.',
      pdfHead: 'EWB No.',
      field: 'EWayBillNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 11,
    },
    {
      header: 'Eway Bill Date',
      pdfHead: 'EWB Date',
      field: 'EwayBillDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 12,
    },
    {
      header: 'Consignment Type',
      pdfHead: 'Cons.\nType',
      field: 'ConsType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 13,
    },
    {
      header: 'Method Of Packaging',
      pdfHead: 'Method\nof Pkg',
      field: 'MOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 14,
    },
    {
      header: 'NOP',
      pdfHead: 'NOP',
      field: 'NOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 15,
    },
    {
      header: 'Goods Value',
      pdfHead: 'Goods\nValue',
      field: 'GoodsValue',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 16,
    },
    {
      header: 'Act. Weight',
      pdfHead: 'Act.\nWght.',
      field: 'AWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 17,
    },
    {
      header: 'Chrg. Weight',
      pdfHead: 'Chrg.\nWght.',
      field: 'CWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 18,
    },
    {
      header: 'Rate',
      pdfHead: 'Rate',
      field: 'Rate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 19,
    },
    {
      header: 'Freight Charges',
      pdfHead: 'Frt.\nChrg.',
      field: 'Freight',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 20,
    },
    {
      header: 'Document Charges',
      pdfHead: 'Doc.\nChrg.',
      field: 'DocCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 21,
    },
    {
      header: 'Cartage Charge',
      pdfHead: 'Cart.\nChrg.',
      field: 'CartageCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 22,
    },
    {
      header: 'Pickup Cartage',
      pdfHead: 'Pick.\nCart.',
      field: 'PickupCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 23,
    },
    {
      header: 'Comm. Cartage',
      pdfHead: 'Com.\nCart.',
      field: 'CommCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 24,
    },
   
    {
      header: 'Return Cartage',
      pdfHead: 'Rtrn.\nCart.',
      field: 'ReturnCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 25,
    },
    {
      header: 'Mscl. Cartage.',
      pdfHead: 'Mscl.\nCart.',
      field: 'MsclCart',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 26,
    },
    {
      header: 'Delivery Cartage',
      pdfHead: 'Mscl.\nCart.',
      field: 'DeliveryCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 27,
    },
    {
      header: 'Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'HamaliCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 28,
    },
    {
      header: 'Operator Hamali Charges',
      pdfHead: 'Op.\nHam.',
      field: 'OperatorHamaliChg',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 29,
    },
    {
      header: 'Val. Charges',
      pdfHead: 'Val.\nChrg.',
      field: 'Insurance',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 30,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Oth.\nChrg.',
      field: 'BookingOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 31,
    },
    {
      header: 'Booking GST',
      pdfHead: 'Bkg.\nGST.',
      field: 'BookingGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 32,
    },
    {
      header: 'Net Booking Amount',
      pdfHead: 'Net Bkg.\nAmt.',
      field: 'BookingNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 33,
    },
    {
      header: 'Created By User',
      pdfHead: 'Created\nBy User',
      field: 'CreatedByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 34,
    },
    {
      header: 'Current City & Current Branch',
      pdfHead: 'Curr. City\nCurr. Br.',
      field: 'currCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 35,
    },
    {
      header: 'Status',
      pdfHead: 'Status',
      field: 'Status',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 36,
    },
    {
      header: 'Refund Amount',
      pdfHead: 'Refund\nAmount',
      field: 'RefundAmt',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 37,
    },
    {
      header: 'Refund Date & Refund Time',
      pdfHead: 'Ref. Date\nRef. Time',
      field: 'RefundDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 38,
    },
    {
      header: 'Refund By User',
      pdfHead: 'Ref. By\nUser',
      field: 'RefundBy',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 39,
    },
    {
      header: 'Dispatch City & Dispatch Branch',
      pdfHead: 'Disp. CityDisp. Br.',
      field: 'dispCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 40,
    },
    {
      header: 'Dispatch Date & Dispatch Time',
      pdfHead: 'Disp. DateDisp. Time',
      field: 'dispDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 41,
    },
    {
      header: 'Dispatch Chalan & Dispatch Vehicle',
      pdfHead: 'Disp. Chln.\nDisp.Veh.',
      field: 'dispChlnVeh',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 42,
    },
    {
      header: 'Dispatch By User',
      pdfHead: 'Disp. By\nUser',
      field: 'DispByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 43,
    },
    {
      header: 'Received City &  Received Branch',
      pdfHead: 'Recd. City\nRecd. Br.',
      field: 'recdCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 44,
    },
    {
      header: 'Received Date & Received Time',
      pdfHead: 'Recd. Date\nRecd. Time',
      field: 'recdDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 45,
    },
    {
      header: 'Received In & Vehicle Number',
      pdfHead: 'Recd. In\nVeh. No',
      field: 'ReceivedDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 46,
    },
    {
      header: 'Received By User',
      pdfHead: 'Recd.By<br />User',
      field: 'RecvByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 47,
    },
    {
      header: 'Delivery City & Delivery Branch',
      pdfHead: 'Del. City\nDel. Br.',
      field: 'delCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 48,
    },
    {
      header: 'Delivery Date & Delivery Time',
      pdfHead: 'Del. Date\nDel. Time',
      field: 'delDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 49,
    },
    {
      header: 'Delivery By Vehicle & Delivery By User',
      pdfHead: 'Del. By Veh\nDel. By User',
      field: 'delVehUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 50,
    },
    {
      header: 'Delivery Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'DeliveryHamali',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 51,
    },
    {
      header: ' Demurrage Chrarges',
      pdfHead: 'Demm.\nChrg.',
      field: 'Demurrage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 52,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Other\nChrg.',
      field: 'DelOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 53,
    },
    {
      header: 'Delivery GST',
      pdfHead: 'Del.\nGST',
      field: 'DeliveryGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 54,
    },
    {
      header: 'Net Delivery Amount',
      pdfHead: 'Net Del.\nAmt',
      field: 'DelNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 55,
    },
    {
      header: 'Delivery Comments',
      pdfHead: 'Del.\nComments',
      field: 'DeliveryComments',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 56,
    },
  ]
  export const bookingDeliveryTrackingColumnsFormattedLRNO = [
    {
      header: 'Formatted LRNO',
      pdfHead: 'Formatted LRNO\nMan. LR No.',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 1,
    },
    {
      header: 'Booking Date & Time',
      pdfHead: 'Bkg. Date\nBkg. Time',
      field: 'BookingDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 2,
    },
    {
      header: 'Source City & Source Branch',
      pdfHead: 'Src. City\nSrc. Br.',
      field: 'srcCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 3,
    },
    {
      header: 'Destination City & Destination Branch',
      pdfHead: 'Dest. City\nDest. Br.',
      field: 'destCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,  
      isMandatory: true,
      id: 4,
    },
    {
      header: 'Sender Name & Sender No.',
      pdfHead: 'Sndr. Name<br />Sndr. No.',
      field: 'sndrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 5,
    },
    {
      header: 'Sender GSTIN & Sender Email',
      pdfHead: 'Sndr. GSTIN\nSndr. eMail',
      field: 'sndrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 6,
    },
    {
      header: 'Receiver Name & Receiver No.',
      pdfHead: 'Rcvr. Name<br />Rcvr. No.',
      field: 'rcvrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 7,
    },
    {
      header: 'Receiver GSTIN & Receiver eMail',
      pdfHead: 'Rcvr. GSTIN<br />Rcvr. eMail ',
      field: 'rcvrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 8,
    },
    {
      header: 'Party Bill No. & Party Bill Date',
      pdfHead: 'Party Bill No.\nParty Bill Dt.',
      field: 'partyBillNoDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 9,
    },
    {
      header: 'Payment Type',
      pdfHead: 'Pymt.\nType',
      field: 'PaymentType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 10,
    },
    {
      header: 'Eway Bill No.',
      pdfHead: 'EWB No.',
      field: 'EWayBillNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 11,
    },
    {
      header: 'Eway Bill Date',
      pdfHead: 'EWB Date',
      field: 'EwayBillDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 12,
    },
    {
      header: 'Consignment Type',
      pdfHead: 'Cons.\nType',
      field: 'ConsType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 13,
    },
    {
      header: 'Method Of Packaging',
      pdfHead: 'Method\nof Pkg',
      field: 'MOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 14,
    },
    {
      header: 'NOP',
      pdfHead: 'NOP',
      field: 'NOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 15,
    },
    {
      header: 'Goods Value',
      pdfHead: 'Goods\nValue',
      field: 'GoodsValue',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 16,
    },
    {
      header: 'Act. Weight',
      pdfHead: 'Act.\nWght.',
      field: 'AWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 17,
    },
    {
      header: 'Chrg. Weight',
      pdfHead: 'Chrg.\nWght.',
      field: 'CWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 18,
    },
    {
      header: 'Rate',
      pdfHead: 'Rate',
      field: 'Rate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 19,
    },
    {
      header: 'Freight Charges',
      pdfHead: 'Frt.\nChrg.',
      field: 'Freight',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 20,
    },
    {
      header: 'Document Charges',
      pdfHead: 'Doc.\nChrg.',
      field: 'DocCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 21,
    },
    {
      header: 'Cartage Charge',
      pdfHead: 'Cart.\nChrg.',
      field: 'CartageCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 22,
    },
    {
      header: 'Pickup Cartage',
      pdfHead: 'Pick.\nCart.',
      field: 'PickupCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 23,
    },
    {
      header: 'Comm. Cartage',
      pdfHead: 'Com.\nCart.',
      field: 'CommCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 24,
    },
   
    {
      header: 'Return Cartage',
      pdfHead: 'Rtrn.\nCart.',
      field: 'ReturnCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 25,
    },
    {
      header: 'Mscl. Cartage.',
      pdfHead: 'Mscl.\nCart.',
      field: 'MsclCart',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 26,
    },
    {
      header: 'Delivery Cartage',
      pdfHead: 'Mscl.\nCart.',
      field: 'DeliveryCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 27,
    },
    {
      header: 'Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'HamaliCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 28,
    },
    {
      header: 'Operator Hamali Charges',
      pdfHead: 'Op.\nHam.',
      field: 'OperatorHamaliChg',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 29,
    },
    {
      header: 'Val. Charges',
      pdfHead: 'Val.\nChrg.',
      field: 'Insurance',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 30,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Oth.\nChrg.',
      field: 'BookingOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 31,
    },
    {
      header: 'Booking GST',
      pdfHead: 'Bkg.\nGST.',
      field: 'BookingGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 32,
    },
    {
      header: 'Net Booking Amount',
      pdfHead: 'Net Bkg.\nAmt.',
      field: 'BookingNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 33,
    },
    {
      header: 'Created By User',
      pdfHead: 'Created\nBy User',
      field: 'CreatedByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 34,
    },
    {
      header: 'Current City & Current Branch',
      pdfHead: 'Curr. City\nCurr. Br.',
      field: 'currCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 35,
    },
    {
      header: 'Status',
      pdfHead: 'Status',
      field: 'Status',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 36,
    },
    {
      header: 'Refund Amount',
      pdfHead: 'Refund\nAmount',
      field: 'RefundAmt',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 37,
    },
    {
      header: 'Refund Date & Refund Time',
      pdfHead: 'Ref. Date\nRef. Time',
      field: 'RefundDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 38,
    },
    {
      header: 'Refund By User',
      pdfHead: 'Ref. By\nUser',
      field: 'RefundBy',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 39,
    },
    {
      header: 'Dispatch City & Dispatch Branch',
      pdfHead: 'Disp. CityDisp. Br.',
      field: 'dispCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 40,
    },
    {
      header: 'Dispatch Date & Dispatch Time',
      pdfHead: 'Disp. DateDisp. Time',
      field: 'dispDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 41,
    },
    {
      header: 'Dispatch Chalan & Dispatch Vehicle',
      pdfHead: 'Disp. Chln.\nDisp.Veh.',
      field: 'dispChlnVeh',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 42,
    },
    {
      header: 'Dispatch By User',
      pdfHead: 'Disp. By\nUser',
      field: 'DispByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 43,
    },
    {
      header: 'Received City &  Received Branch',
      pdfHead: 'Recd. City\nRecd. Br.',
      field: 'recdCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 44,
    },
    {
      header: 'Received Date & Received Time',
      pdfHead: 'Recd. Date\nRecd. Time',
      field: 'recdDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 45,
    },
    {
      header: 'Received In & Vehicle Number',
      pdfHead: 'Recd. In\nVeh. No',
      field: 'ReceivedDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 46,
    },
    {
      header: 'Received By User',
      pdfHead: 'Recd.By<br />User',
      field: 'RecvByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 47,
    },
    {
      header: 'Delivery City & Delivery Branch',
      pdfHead: 'Del. City\nDel. Br.',
      field: 'delCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 48,
    },
    {
      header: 'Delivery Date & Delivery Time',
      pdfHead: 'Del. Date\nDel. Time',
      field: 'delDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 49,
    },
    {
      header: 'Delivery By Vehicle & Delivery By User',
      pdfHead: 'Del. By Veh\nDel. By User',
      field: 'delVehUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 50,
    },
    {
      header: 'Delivery Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'DeliveryHamali',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 51,
    },
    {
      header: ' Demurrage Chrarges',
      pdfHead: 'Demm.\nChrg.',
      field: 'Demurrage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 52,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Other\nChrg.',
      field: 'DelOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 53,
    },
    {
      header: 'Delivery GST',
      pdfHead: 'Del.\nGST',
      field: 'DeliveryGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 54,
    },
    {
      header: 'Net Delivery Amount',
      pdfHead: 'Net Del.\nAmt',
      field: 'DelNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 55,
    },
    {
      header: 'Delivery Comments',
      pdfHead: 'Del.\nComments',
      field: 'DeliveryComments',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 56,
    },
  ]
  export const bookingDeliveryTrackingColumnsForBoth = [
    {
      header: 'LR No.',
      pdfHead: 'LR No.\nMan. LR No.',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 1,
    },
    {
      header: 'Formatted LRNO',
      pdfHead: 'Formatted LRNO\nMan. LR No.',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 57,
    },
    {
      header: 'Booking Date & Time',
      pdfHead: 'Bkg. Date\nBkg. Time',
      field: 'BookingDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 2,
    },
    {
      header: 'Source City & Source Branch',
      pdfHead: 'Src. City\nSrc. Br.',
      field: 'srcCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 3,
    },
    {
      header: 'Destination City & Destination Branch',
      pdfHead: 'Dest. City\nDest. Br.',
      field: 'destCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,  
      isMandatory: true,
      id: 4,
    },
    {
      header: 'Sender Name & Sender No.',
      pdfHead: 'Sndr. Name<br />Sndr. No.',
      field: 'sndrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 5,
    },
    {
      header: 'Sender GSTIN & Sender Email',
      pdfHead: 'Sndr. GSTIN\nSndr. eMail',
      field: 'sndrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 6,
    },
    {
      header: 'Receiver Name & Receiver No.',
      pdfHead: 'Rcvr. Name<br />Rcvr. No.',
      field: 'rcvrNameNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 7,
    },
    {
      header: 'Receiver GSTIN & Receiver eMail',
      pdfHead: 'Rcvr. GSTIN<br />Rcvr. eMail ',
      field: 'rcvrGstinEmail',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 8,
    },
    {
      header: 'Party Bill No. & Party Bill Date',
      pdfHead: 'Party Bill No.\nParty Bill Dt.',
      field: 'partyBillNoDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 9,
    },
    {
      header: 'Payment Type',
      pdfHead: 'Pymt.\nType',
      field: 'PaymentType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 10,
    },
    {
      header: 'Eway Bill No.',
      pdfHead: 'EWB No.',
      field: 'EWayBillNo',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 11,
    },
    {
      header: 'Eway Bill Date',
      pdfHead: 'EWB Date',
      field: 'EwayBillDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 12,
    },
    {
      header: 'Consignment Type',
      pdfHead: 'Cons.\nType',
      field: 'ConsType',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 13,
    },
    {
      header: 'Method Of Packaging',
      pdfHead: 'Method\nof Pkg',
      field: 'MOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 14,
    },
    {
      header: 'NOP',
      pdfHead: 'NOP',
      field: 'NOP',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 15,
    },
    {
      header: 'Goods Value',
      pdfHead: 'Goods\nValue',
      field: 'GoodsValue',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 16,
    },
    {
      header: 'Act. Weight',
      pdfHead: 'Act.\nWght.',
      field: 'AWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 17,
    },
    {
      header: 'Chrg. Weight',
      pdfHead: 'Chrg.\nWght.',
      field: 'CWEIGHT',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 18,
    },
    {
      header: 'Rate',
      pdfHead: 'Rate',
      field: 'Rate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 19,
    },
    {
      header: 'Freight Charges',
      pdfHead: 'Frt.\nChrg.',
      field: 'Freight',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 20,
    },
    {
      header: 'Document Charges',
      pdfHead: 'Doc.\nChrg.',
      field: 'DocCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 21,
    },
    {
      header: 'Cartage Charge',
      pdfHead: 'Cart.\nChrg.',
      field: 'CartageCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 22,
    },
    {
      header: 'Pickup Cartage',
      pdfHead: 'Pick.\nCart.',
      field: 'PickupCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 23,
    },
    {
      header: 'Comm. Cartage',
      pdfHead: 'Com.\nCart.',
      field: 'CommCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 24,
    },
   
    {
      header: 'Return Cartage',
      pdfHead: 'Rtrn.\nCart.',
      field: 'ReturnCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 25,
    },
    {
      header: 'Mscl. Cartage.',
      pdfHead: 'Mscl.\nCart.',
      field: 'MsclCart',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 26,
    },
    {
      header: 'Delivery Cartage',
      pdfHead: 'Mscl.\nCart.',
      field: 'DeliveryCartage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 27,
    },
    {
      header: 'Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'HamaliCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 28,
    },
    {
      header: 'Operator Hamali Charges',
      pdfHead: 'Op.\nHam.',
      field: 'OperatorHamaliChg',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 29,
    },
    {
      header: 'Val. Charges',
      pdfHead: 'Val.\nChrg.',
      field: 'Insurance',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 30,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Oth.\nChrg.',
      field: 'BookingOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 31,
    },
    {
      header: 'Booking GST',
      pdfHead: 'Bkg.\nGST.',
      field: 'BookingGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 32,
    },
    {
      header: 'Net Booking Amount',
      pdfHead: 'Net Bkg.\nAmt.',
      field: 'BookingNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 33,
    },
    {
      header: 'Created By User',
      pdfHead: 'Created\nBy User',
      field: 'CreatedByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 34,
    },
    {
      header: 'Current City & Current Branch',
      pdfHead: 'Curr. City\nCurr. Br.',
      field: 'currCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 35,
    },
    {
      header: 'Status',
      pdfHead: 'Status',
      field: 'Status',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 36,
    },
    {
      header: 'Refund Amount',
      pdfHead: 'Refund\nAmount',
      field: 'RefundAmt',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 37,
    },
    {
      header: 'Refund Date & Refund Time',
      pdfHead: 'Ref. Date\nRef. Time',
      field: 'RefundDate',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 38,
    },
    {
      header: 'Refund By User',
      pdfHead: 'Ref. By\nUser',
      field: 'RefundBy',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 39,
    },
    {
      header: 'Dispatch City & Dispatch Branch',
      pdfHead: 'Disp. CityDisp. Br.',
      field: 'dispCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 40,
    },
    {
      header: 'Dispatch Date & Dispatch Time',
      pdfHead: 'Disp. DateDisp. Time',
      field: 'dispDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 41,
    },
    {
      header: 'Dispatch Chalan & Dispatch Vehicle',
      pdfHead: 'Disp. Chln.\nDisp.Veh.',
      field: 'dispChlnVeh',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 42,
    },
    {
      header: 'Dispatch By User',
      pdfHead: 'Disp. By\nUser',
      field: 'DispByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 43,
    },
    {
      header: 'Received City &  Received Branch',
      pdfHead: 'Recd. City\nRecd. Br.',
      field: 'recdCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 44,
    },
    {
      header: 'Received Date & Received Time',
      pdfHead: 'Recd. Date\nRecd. Time',
      field: 'recdDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 45,
    },
    {
      header: 'Received In & Vehicle Number',
      pdfHead: 'Recd. In\nVeh. No',
      field: 'ReceivedDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 46,
    },
    {
      header: 'Received By User',
      pdfHead: 'Recd.By<br />User',
      field: 'RecvByUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 47,
    },
    {
      header: 'Delivery City & Delivery Branch',
      pdfHead: 'Del. City\nDel. Br.',
      field: 'delCityBranch',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 48,
    },
    {
      header: 'Delivery Date & Delivery Time',
      pdfHead: 'Del. Date\nDel. Time',
      field: 'delDateTime',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 49,
    },
    {
      header: 'Delivery By Vehicle & Delivery By User',
      pdfHead: 'Del. By Veh\nDel. By User',
      field: 'delVehUser',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 50,
    },
    {
      header: 'Delivery Hamali Charges',
      pdfHead: 'Ham.\nChrg.',
      field: 'DeliveryHamali',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 51,
    },
    {
      header: ' Demurrage Chrarges',
      pdfHead: 'Demm.\nChrg.',
      field: 'Demurrage',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 52,
    },
    {
      header: 'Other Charges',
      pdfHead: 'Other\nChrg.',
      field: 'DelOtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 53,
    },
    {
      header: 'Delivery GST',
      pdfHead: 'Del.\nGST',
      field: 'DeliveryGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 54,
    },
    {
      header: 'Net Delivery Amount',
      pdfHead: 'Net Del.\nAmt',
      field: 'DelNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 55,
    },
    {
      header: 'Delivery Comments',
      pdfHead: 'Del.\nComments',
      field: 'DeliveryComments',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 56,
    },
  ]
export const bookAndDelHeader = () => {
  return [
    {
      id: 0,
      header: "S/N",
      exportHead: "Serial Number",
      field: "SN",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: xlCol,
      weight:120,
    },
    {
      id: 0,
      header: "LR No.",
      exportHead: "LR Number",
      field: "LRNO",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: xlCol,
      weight:120,
    },
    {
      id: 0,
      header: "Man. LR No.",
      exportHead: "Manual LR Number",
      field: "ManualLRNo",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: xlCol,
      weight:120,
    },
    {
      id: 1,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      xlCol: xlCol,
      weight:120,
    },
    {
      id: 2, header: 'Booking Dat', exportHead: 'Booking Dat', field: 'BookingDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
      id: 2, header: 'Booking Time', exportHead: 'Booking Time', field: 'BookingTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 3, header: 'Src. City', exportHead: 'Source City', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
      id: 3, header: 'Src. Br.', exportHead: 'Source Branch', field: 'SourceBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 4, header: 'Dest. City', exportHead: 'Destination City', field: 'DestCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
      id: 4, header: 'Dest. Br.', exportHead: 'Destination Branch', field: 'DestBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 5, header: 'Sndr. Name', exportHead: 'Sender Name', field: 'Sender', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
      id: 5, header: 'Sndr. No.', exportHead: 'Sender Mobile Number', field: 'SenderMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 6, header: 'Sndr. GSTIN', exportHead: 'Sender GSTIN', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
      id: 6, header: 'Sndr. eMail', exportHead: 'Sender eMail', field: 'SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 7, header: 'Rcvr. Name', exportHead: 'Rcvr. Name', field: 'RecName', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
      id: 7, header: 'Rcvr. No.', exportHead: 'Rcvr. No.', field: 'RecMobileNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 8, header: 'Rcvr. GSTIN', exportHead: 'Receiver GSTIN', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
      id: 8, header: 'Rcvr. eMail', exportHead: 'Receiver eMail', field: 'ReceiverEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 9, header: 'Party Bill No.', exportHead: 'Party Bill No.', field: 'PartyBillNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
      id: 9, header: 'Party Bill Dt.', exportHead: 'Party Bill Dt.', field: 'PartyBillDate', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 10, header: 'Payment\nType', exportHead: 'Payment\nType', field: 'PaymentType', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 11, header: 'Eway\nBill No.', exportHead: 'Eway\nBill No.', field: 'EWayBillNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 12, header: 'Eway\nBill Date', exportHead: 'Eway\nBill Date', field: 'EwayBillDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 13, header: 'Consignment\nType', exportHead: 'Consignment\nType', field: 'ConsType', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, weight:120,
    },
    {
      id: 14, header: 'Method\nOf Packaging', exportHead: 'Method\nOf Packaging', field: 'MOP', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 15, header: 'NOP', exportHead: 'NOP', field: 'NOP', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 16, header: 'Goods\nValue', exportHead: 'Goods\nValue', field: 'GoodsValue', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 17, header: 'Act.\nWeight', exportHead: 'Actual\nWeight', field: 'AWEIGHT', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 18, header: 'Chrg.\nWeight', exportHead: 'Chrg.\nWeight', field: 'CWEIGHT', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 19, header: 'Rate', exportHead: 'Rate', field: 'Rate', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 20, header: 'Freight\nCharges', exportHead: 'Freight\nCharges', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq, weight:120,
    },
    {
      id: 21, header: 'Document\nCharges', exportHead: 'Document\nCharges', field: 'DocCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 22, header: 'Cartage\nCharge', exportHead: 'Cartage\nCharge', field: 'CartageCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 23, header: 'Pickup\nCartage', exportHead: 'Pickup\nCartage', field: 'PickupCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 24, header: 'Comm.\nCartage', exportHead: 'Comm.\nCartage', field: 'CommCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 25, header: 'Return\nCartage', exportHead: 'Return\nCartage', field: 'ReturnCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 26, header: 'Mscl.\nCartage.', exportHead: 'Miscellaneous\nCartage', field: 'MsclCart', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 27, header: 'Delivery\nCartage', exportHead: 'Delivery\nCartage', field: 'DeliveryCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 28, header: 'Hamali\nCharges', exportHead: 'Hamali\nCharges', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 29, header: 'Operator\nHamali Charges', exportHead: 'Operator\nHamali Charges', field: 'OperatorHamaliChg', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 30, header: 'Val.\nCharges', exportHead: 'Valuation\nCharges', field: 'Insurance', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 31, header: 'Other\nCharges', exportHead: 'Other\nCharges', field: 'BookingOtherCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 32, header: 'Booking\nGST', exportHead: 'Booking\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 33, header: 'Net Booking\nAmount', exportHead: 'Net Booking\nAmount', field: 'BookingNetAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 34, header: 'Created\nBy User', exportHead: 'Created\nBy User', field: 'CreatedByUser', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 35, header: 'Current City &\nCurrent Branch', exportHead: 'Current City &\nCurrent Branch', field: 'currCityBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 36, header: 'Status', exportHead: 'Status', field: 'Status', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 37, header: 'Refund\nAmount', exportHead: 'Refund\nAmount', field: 'RefundAmt', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 38, header: 'Refund Date &\nRefund Time', exportHead: 'Refund Date &\nRefund Time', field: 'RefundDate', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 39, header: 'Refund\nBy User', exportHead: 'Refund\nBy User', field: 'RefundBy', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 40, header: 'Dispatch City &\nDispatch Branch', exportHead: 'Dispatch City &\nDispatch Branch', field: 'dispCityBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 41, header: 'Dispatch Date &\nDispatch Time', exportHead: 'Dispatch Date &\nDispatch Time', field: 'dispDateTime', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 42, header: 'Dispatch Chalan &\nDispatch Vehicle', exportHead: 'Dispatch Chalan &\nDispatch Vehicle', field: 'dispChlnVeh', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 43, header: 'Dispatch\nBy User', exportHead: 'Dispatch\nBy User', field: 'DispByUser', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 44, header: 'Received City &\nReceived Branch', exportHead: 'Received City &\nReceived Branch', field: 'recdCityBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 45, header: 'Received Date &\nReceived Time', exportHead: 'Received Date &\nReceived Time', field: 'recdDateTime', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 47, header: 'Received In &\nVehicle Number', exportHead: 'Received In &\nVehicle Number', field: 'ReceivedDateTime', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 49, header: 'Received\nBy User', exportHead: 'Received\nBy User', field: 'RecvByUser', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 50, header: 'Delivery City &\nDelivery Branch', exportHead: 'Delivery City &\nDelivery Branch', field: 'delCityBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 51, header: 'Delivery Date &\nDelivery Time', exportHead: 'Delivery Date &\nDelivery Time', field: 'delDateTime', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 52, header: 'Delivery By Vehicle &\nDelivery By User', exportHead: 'Delivery By Vehicle &\nDelivery By User', field: 'delVehUser', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
    {
      id: 53, header: 'Delivery\nHamali Charges', exportHead: 'Delivery\nHamali Charges', field: 'DeliveryHamali', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 54, header: 'Demurrage\nCharges', exportHead: 'Demurrage\nCharges', field: 'Demurrage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 55, header: 'Other\nCharges', exportHead: 'Other\nCharges', field: 'DelOtherCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 56, header: 'Delivery\nGST', exportHead: 'Delivery\nGST', field: 'DeliveryGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 57, header: 'Net Delivery\nAmount', exportHead: 'Net Delivery\nAmount', field: 'DelNetAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, weight:120,
    },
    {
      id: 58, header: 'Delivery\nComments', exportHead: 'Delivery\nComments', field: 'DeliveryComments', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, weight:120,
    },
  ].filter(Boolean)
}
export const summaryTableHead = [
  { header: 'S/N', field: 'sn',xlCol:xlCol,width: '40px' },
  { header: 'LR / WayBill No.', field: 'LRNO',xlCol:xlCol,width: '130px' },
  { header: 'Formatted LRNO', field: 'FormattedLRNO',xlCol:xlCol,width: '130px' },
  { header: 'Man LR No.', field: 'ManualLRNo',xlCol:xlCol,width: '120px' },
  { header: 'Bkg. Date', field: 'BookingDateFormated',xlCol:xlCol,width: '90px' },
  { header: 'Bkg. Time', field: 'BookingTimeFormated',xlCol:xlCol,width: '90px' },
  { header: 'Src. City', field: 'SourceCity',xlCol:xlCol,width: '120px' },
  { header: 'Dest. City', field: 'DestCity',xlCol:xlCol,width: '120px' },
  { header: 'Pymt. Type', field: 'PaymentType',field2:'PaymentType',xlCol:xlCol,width: '120px' },
  { header: 'Cons. Type', field: 'ConsType',field2:'ConsType',xlCol:xlCol,width: '120px' },
  { header: 'NOP', field: 'NOP',xlCol:xlColq,width: '50px' },
  { header: 'Created By User', field: 'CreatedByUser',xlCol:xlCol,width: '100px' },
  { header: 'Status', field: 'Status', field2:'Status',xlCol:xlCol,width: '140px' },
  { header: 'Ref. Date', field: 'RefundDate',xlCol:xlCol,width: '100px' },
  { header: 'Ref. Time', field: 'RefundTime',xlCol:xlCol,width: '100px' },
  { header: 'Ref. By User', field: 'RefundBy',xlCol:xlCol,width: '120px' },
  { header: 'Disp. Date', field: 'DispatchDateTimeFormated',xlCol:xlCol,width: '100px' },
  { header: 'Disp. Time', field: 'DispatchDateTimeFormated',xlCol:xlCol,width: '100px' },
  { header: 'Disp. Veh.', field: 'VehicleNo',xlCol:xlCol,width: '110px' },
  { header: 'Disp. By User', field: 'DispByUser',xlCol:xlCol,width: '120px' },
  { header: 'Recd. Date', field: 'ReceiveDateFormated',xlCol:xlCol,width: '90px' },
  { header: 'Recd. Time', field: 'ReceiveTimeFormated',xlCol:xlCol,width: '90px' },
  { header: 'Recd. In Veh.', field: 'ReceivedDateTime',xlCol:xlCol,width: '110px' },
  { header: 'Recd.By User', field: 'RecvByUser',xlCol:xlCol,width: '120px' },
  { header: 'Del. Date', field: 'DeliveryDateFormated',xlCol:xlCol,width: '90px' },
  { header: 'Del. Time', field: 'DeliveryTimeFormated',xlCol:xlCol,width: '90px' },
  { header: 'Del. By User', field: 'DeliveredBy',xlCol:xlCol,width: '120px' },
  { header: 'Del. Comments', field: 'DeliveryComments',xlCol:xlCol,width: '120px' },
]

export const filterHeaders = [
  { field: 'SourceStateID', header: 'Source State', textAlign: 'left' },
  { field: 'SourceCityID', header: 'Source City', textAlign: 'left' },
  { field: 'SourceBranchID', header: 'Source Branch', textAlign: 'left' },
  { field: 'DestStateID', header: 'Destination State', textAlign: 'left' },
  { field: 'DestCityID', header: 'Destination City', textAlign: 'left' },
  { field: 'DestBranchID', header: 'Destination Branch', textAlign: 'left' },
  { field: 'PaymentType', header: 'Payment Type', textAlign: 'left' },
  { field: 'ConsTypeID', header: 'Consignment Type', textAlign: 'left' },
  { field: 'ReportMode', header: 'Report Mode', textAlign: 'left' },

]

export const bookAndDelHeaderForSTA = () => {
  return [
    { id: 1, header: 'S/N',xlCol: xlCol, field: 'SN' },
    { id: 2, header: 'Booking Date',xlCol: xlCol, field: 'BookingDate' },
    { id: 3, header: 'Booking Time',xlCol: xlCol, field: 'BookingTime' },
    { id: 4, header: 'LR Cancel Date',xlCol: xlCol, field: 'RefundDate' },
    { id: 5, header: 'LR Cancel Time',xlCol: xlCol, field: 'RefundTime' },
    { id: 6, header: 'LR Number',xlCol: xlCol, field: 'LRNO' },
    { id: 7, header: 'LR Type',xlCol: xlCol, field: 'PaymentType' },
    { id: 8, header: 'Source State',xlCol: xlCol, field: 'SourceState' },
    { id: 9, header: 'Source City',xlCol: xlCol, field: 'SourceCity' },
    { id: 10, header: 'Source Branch',xlCol: xlCol, field: 'SourceBranch' },
    { id: 11, header: 'Destination State',xlCol: xlCol, field: 'DestinationState' },
    { id: 12, header: 'Destination City',xlCol: xlCol, field: 'DestCity' },
    { id: 13, header: 'Destination Branch',xlCol: xlCol, field: 'DestBranch' },
    { id: 14, header: 'Consignor',xlCol: xlCol, field: 'Sender' },
    { id: 15, header: 'Consignor No.',xlCol: xlCol, field: 'SenderMobileNo' },
    { id: 16, header: 'Consignee',xlCol: xlCol, field: 'RecName' },
    { id: 17, header: 'Consignee No.',xlCol: xlCol, field: 'RecMobileNo' },
    { id: 18, header: 'Consignor GSTIN',xlCol: xlCol, field: 'SenderGSTN' },
    { id: 19, header: 'Consignee GSTIN',xlCol: xlCol, field: 'ReceiverGSTN' },
    { id: 20, header: 'Art',xlCol: xlColq, field: 'NOP' },
    { id: 21, header: 'Art Type',xlCol: xlCol, field: 'ConsType' },
    { id: 22, header: 'Act Wgt',xlCol: xlColq, field: 'AWEIGHT' },
    { id: 23, header: 'Chrg Wgt',xlCol: xlColq, field: 'CWEIGHT' },
    { id: 24, header: 'CFT in KG',xlCol: xlColq, field: 'CFTinkg' },
    { id: 25, header: 'CFT Size',xlCol: xlCol, field: 'CFTSize' },
    { id: 26, header: 'Rate',xlCol: xlCol, field: 'Rate', align: 'right' },
    { id: 27, header: 'Freight',xlCol: xlColq, field: 'Freight' },
    { id: 28, header: 'Document',xlCol: xlColq, field: 'DocCharge' },
    { id: 29, header: 'Valuation',xlCol: xlColq, field: 'Insurance' },
    { id: 30, header: 'Pickup Cartage',xlCol: xlColq, field: 'PickupCartage' },
    { id: 31, header: 'Drop Cartage',xlCol: xlColq, field: 'DeliveryCartage' },
    { id: 32, header: 'Miscellaneous Cartage',xlCol: xlColq, field: 'MsclCart' },
    { id: 33, header: 'ToPay Charge',xlCol: xlColq, field: 'OperatorHamaliChg' },
    { id: 34, header: 'Cancelled LR Penalty',xlCol: xlColq, field: 'CancelledLRPenalty' },
    { id: 35, header: 'Total Collection',xlCol: xlColq, field: 'BookingNetAmount' },
    { id: 36, header: 'Dammurage',xlCol: xlColq, field: 'Demurrage' },
    { id: 37, header: 'Delivery Hamali',xlCol: xlColq, field: 'DeliveryHamali' },
    { id: 38, header: 'Auto Charges',xlCol: xlColq, field: 'DeliveryCartage' },
    { id: 39, header: 'Status',xlCol: xlCol, field: 'Status' },
    { id: 40, header: 'Eway Bill Exempted',xlCol: xlCol, field: 'EwayBillExampted' },
    { id: 41, header: 'Ewaybill No',xlCol: xlCol, field: 'EWayBillNo' },
    { id: 42, header: 'Invoice No',xlCol: xlCol, field: 'PartyBillNo', align: 'right' },
    { id: 43, header: 'Invoice Value',xlCol: xlColq, field: 'BillAmount' },
    { id: 44, header: 'Goods Value',xlCol: xlColq, field: 'GoodsValue', align: 'right' },
    { id: 45, header: '1st LS Date',xlCol: xlCol, field: 'DispatchDateTime' },
    { id: 46, header: '1st LS Vehicle',xlCol: xlCol, field: 'VehicleNo' },
    { id: 47, header: 'Last LS Receive Date',xlCol: xlCol, field: 'ReceiveDate' },
    { id: 48, header: 'Last LS Vehicle',xlCol: xlCol, field: 'LastLSVehicle' },
    { id: 49, header: 'Current Branch',xlCol: xlCol, field: 'CurrBranch' },
    { id: 50, header: 'Said To Contain',xlCol: xlCol, field: 'Description' },
    { id: 51, header: 'Delivery Date',xlCol: xlCol, field: 'DeliveryDate' },
    { id: 52, header: 'Pick Up Cartage Remarks',xlCol: xlCol, field: 'CartageRemarks' },
    { id: 53, header: 'Comment',xlCol: xlCol, field: 'comment' },
    { id: 54, header: 'Delivery Remarks',xlCol: xlCol, field: 'DeliveryComments' },
    { id: 55, header: 'Admin Remarks',xlCol: xlCol, field: 'Destinationchange' },
  ].map(col => ({
    ...col,
    exportHead: col.header,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    weight: 120,
  }))
}